import React from 'react';
import SaveCTA from '../component/common/savecta';
import Contentsubpagemenu from '../component/layout/content-sub-page-menu';
import Header2 from '../component/common/title';
import pic26 from '../assets/pic26.png'
import Input from '../component/common/input';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Popup from '../component/common/popup';
import Selectinput from '../component/common/selectinput';




const Contentmanagementexbitors = () => {


        // const [search, setSearch] = useState('');

        const [popup, setPopup] = useState([]);

        useEffect(() => {
        const getPopup = async()=>{
            const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;
        setPopup(res.data);
        };
        getPopup();
        }, []);




        const [Static, setStatic] = useState([]);
        const [heroTitle, setHeroTitle] = useState("");
        const [Secheader2, setSecheader2] = useState("");

        useEffect(() => {
        const getStatic = async()=>{
            const res = await supabase.from('static_content').select('*').order('id', { ascending: true });
            if (res.data) {
            setStatic(res.data);
            setHeroTitle(res.data?.[8]?.header || "");
            setSecheader2(res.data?.[9]?.header || "");
    
              
                }};
        getStatic();
        }, []);



        const [events, setEvents] = useState([]);

        const [selectedEvent, setSelectedEvent] = useState("");
        const [eventData, setEventData] = useState(null);
        useEffect(() => {
        const fetchData = async () => {

            const { data, error } = await supabase
            .from("exbition_event")
            .select("*")
            .order("id", { ascending: true });

            if (error) {
            console.log(error);   return; }
            setEvents(data || []);
            const ongoingEvent = data.find(
                  (event) => event.status === "ongoing"  );

            if (ongoingEvent) {
            setSelectedEvent(ongoingEvent.id);
            setEventData(ongoingEvent);  } };

        fetchData();
        }, []);




const handleEventChange = (e) => {
  const newEventId = e.target.value;
  setSelectedEvent(newEventId);
  const selected = events.find(item => item.id == newEventId);
  setEventData(selected);
};







        // useEffect(() => {
        // if (!selectedEvent) return;

        // const getEventContent = async () => {
        //     const { data, error } = await supabase
        //     .from("exbition_event")
        //     .select("*")
        //     .eq("id", selectedEvent)
        //     .single();

        //     if (error) {
        //     console.log(error);
        //     return; }  setEventData(data); };

        // getEventContent();
        // }, [selectedEvent]);





        const [Exhibitors, setExhibitors] = useState([]);





        const [selectedExhibitors, setSelectedExhibitors] = useState(Array(3).fill(""));

        useEffect(() => {
        const getExhibitors = async () => {
            const { data, error } = await supabase
            .from("exhibitors").select("*").order('id', { ascending: true });
            if (error) { console.log(error.message); return; }
            setExhibitors(data || []);

            const featured = data.filter(e => e.is_featured);const filled = Array(3).fill("");
            featured.forEach((ex, i) => {
            const slot = ex.featured_position != null ? ex.featured_position - 1 : i;
            if (slot >= 0 && slot < 3) filled[slot] = ex.id; });
            setSelectedExhibitors(filled); };
        getExhibitors();
        }, []);







const [showPopup2, setShowPopup2] = useState(false);
const closePopup2 = () => {
  setShowPopup2(false);
};




const [eventExhibitors, setEventExhibitors] = useState([]);









const saveAll = async () => {
  for (const item of popup) {
    await supabase
    .from("static_content")
    .update({
    header: heroTitle
    })
    .eq("id", Static?.[8]?.id);
  }
    setShowPopup2(true); 



    await supabase
    .from("static_content")
    .update({
    header: Secheader2
    })
    .eq("id", Static?.[9]?.id);
  
    setShowPopup2(true); 


  
  await supabase.from("exbition_event").update({ status: "ended" }).eq("status", "ongoing");
  await supabase.from("exbition_event").update({ status: "ongoing" }).eq("id", selectedEvent);

  const { data: refreshedEvents } = await supabase
    .from("exbition_event")
    .select("*")
    .order("id", { ascending: true });
  if (refreshedEvents) {
    setEvents(refreshedEvents);
  }

  setShowPopup2(true);

};







    return ( 
        

 <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Content Management"  
                            para="Manage website content and pages dynamically"
                            />
                            

                          <section className='container-table2-eventp'>
                            

                            <Contentsubpagemenu />


                            <section className='container-table-eventp'>
                                {/* <fieldset className="input-wrapper">
                                    <input 
                                    className='input-search'
                                     placeholder="Search by section name ..."
                                       value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                   
                                    />

                                     <img src={pic26} className="search-icon" alt="search" />
                                 </fieldset> */}

                                <section className='container-navigation-content'>

                                    <article className='container-part1-navigation-content'>
                                        <article className='header-container-content-change-p'>
                                            <h2 className='header-content-change-page'>Exhibitors Content</h2>
                                            <p className='para-content-change-page'>Manage event exhibitors based on omgoing event</p>
                                        </article>


                                                        <section className='input-container-popup-content'>
                                                            <Input title='Hero Title'
                                                            value={heroTitle}
                                                            onChange={(e) => setHeroTitle(e.target.value)}/>

                                                        </section>



                                                        <section className='input-container-popup-content'>
                                                            <Input title='Section Title'
                                                            value={Secheader2}
                                                            onChange={(e) => setSecheader2(e.target.value)}/>

                                                        </section>

                                                        <Selectinput
                                                            title="Select an Event ( to view its exhibitors )."
                                                            value={selectedEvent}
                                                            onChange={handleEventChange}
                                                            options={events.map((e) => ({
                                                                value: e.id,
                                                                label: `${e.event_name} (${e.status})`
                                                            }))}
                                                        />






                                                    <button
                                                    className='container-save-cta'
                                                    onClick={saveAll}
                                                    
                                                >
                                                    <SaveCTA title='Save Changes' />
                                                </button>



                                    </article>





                                </section>


                    {showPopup2 && (
                            <Popup
                            to="/content-management-navigations" 
                                onClose={closePopup2}
                            img={popup?.[2]?.image} 
                                alt={popup?.[2]?.icon_alt} 
                            header={popup?.[2]?.title}
                            para={popup?.[2]?.paragraph} 
                            title={popup?.[2]?.cta_text_primary} 
                            />
                    )}






                            </section>
                            
                        </section>     
                            

                                
                                  
        </article>

</section>
     );
}
 




export default Contentmanagementexbitors;